<template>
  <ion-page>
    <ion-content
      class="main-background release-page-shell"
      :fullscreen="true"
      slot="fixed"
      :scroll-y="false"
    >
      <div class="release-safe-area"></div>
      <button
        v-show="!isLandscapeMode && !isReleaseMusic"
        type="button"
        class="release-chrome-circle release-chrome-circle--start top-level"
        aria-label="Закрыть"
        @click="returnBack()"
      >
        <ion-icon :icon="closeOutline"></ion-icon>
      </button>
      <button
        v-show="isLandscapeMode && isMobile"
        type="button"
        class="release-chrome-circle release-chrome-circle--start top-level"
        aria-label="Назад"
        @click="returnBack('Programs')"
      >
        <ion-icon :icon="chevronDown"></ion-icon>
      </button>
      <button
        v-show="isReleaseVideo && !isLandscapeMode && isMobile"
        type="button"
        class="release-chrome-circle release-chrome-circle--end top-level"
        aria-label="Полный экран"
        @click="setFullscreenMode(true)"
      >
        <ion-icon :icon="resize"></ion-icon>
      </button>

      <ion-router-outlet id="release-router"></ion-router-outlet>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from "@/model/globalcontext.model";
import { Release } from "@/model/release.model";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation";
import {
  IonContent,
  IonIcon,
  IonPage,
  IonRouterOutlet,
  useBackButton,
} from "@ionic/vue";
import {
  chevronDown,
  closeOutline,
  documentOutline,
  filmOutline,
  musicalNotesOutline,
  resize,
} from "ionicons/icons";
import { defineComponent, inject } from "vue";

export default defineComponent({
  name: "ReleaseMain",
  components: {
    IonContent,
    IonPage,
    IonIcon,
    IonRouterOutlet,
  },

  setup() {
    const globalContext = inject("globalContext") as GlobalContext;
    const isMobile = globalContext.isMobile;
    const releaseEntity = inject("release") as Release;

    return {
      musicalNotesOutline,
      filmOutline,
      documentOutline,
      closeOutline,
      chevronDown,
      resize,
      isMobile,
      releaseEntity,
      globalContext,
    };
  },

  data() {
    return {
      isLandscapeMode: false,
    };
  },

  mounted() {
    try {
      this.$nextTick(() => {
        useBackButton(10, () => {
          this.returnBack();
        });

        ScreenOrientation.onChange().subscribe(() => {
          this.isLandscapeMode =
            ScreenOrientation.type ==
              ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
            ScreenOrientation.type ==
              ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
            ScreenOrientation.type ==
              ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        });
      });
    } catch (ex) {
      //not supported
    }
  },

  computed: {
    isReleaseVideo() {
      return this.$router.currentRoute.value.path === "/video";
    },
    isReleaseMusic() {
      return this.$router.currentRoute.value.path === "/music";
    },
    isReleaseGuide() {
      return this.$router.currentRoute.value.path === "/guide";
    },
  },

  methods: {
    returnBack(componentName?: string) {
      this.setFullscreenMode(false);
      this.$router.replace({ name: componentName ? componentName : "ReleasePage" });
    },
    navigate(releaseDetail: string) {
      this.$router.push({
        name: releaseDetail,
      });
    },
    setFullscreenMode(value: boolean) {
      this.isLandscapeMode = value;
      try {
        if (this.isMobile && this.isLandscapeMode)
          ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.LANDSCAPE);
        else if (this.isMobile) {
          ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT).then(
            () => {
              setTimeout(() => {
                ScreenOrientation.unlock();
              }, 3000);
            }
          );
        }
      } catch (ex) {
        //not supported
      }
    },
  },
});
</script>

<style scoped>
.release-safe-area {
  width: 100vw;
  height: var(--ion-safe-area-top);
}

.release-chrome-circle {
  appearance: none;
  position: absolute;
  top: calc(env(safe-area-inset-top, 0px) + 10px);
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--liga-float-glass-bg, rgba(28, 28, 32, 0.62));
  border: 1px solid var(--liga-float-glass-border, rgba(255, 255, 255, 0.14));
  backdrop-filter: var(--liga-float-glass-blur, blur(18px));
  -webkit-backdrop-filter: var(--liga-float-glass-blur, blur(18px));
  box-shadow: var(--liga-float-glass-shadow, 0 8px 28px rgba(0, 0, 0, 0.28));
  color: var(--liga-chrome-text, #fff);
  z-index: 10050;
  cursor: pointer;
  box-sizing: border-box;
}

.release-chrome-circle--start {
  left: 5vw;
}

.release-chrome-circle--end {
  right: 5vw;
  left: auto;
}

.release-chrome-circle ion-icon {
  font-size: 22px;
  color: var(--liga-chrome-text, #fff);
  pointer-events: none;
}

@media (min-width: 1281px) {
  .release-chrome-circle--end {
    display: none;
  }
}
</style>
